<!--<template>-->
<!--  <div>-->
<!--    <div class="personal_right">-->
<!--      <h2 class="tit6"><img src="../../../static/images/guide_sign4.png">消息中心</h2>-->
<!--      <div class="clear"></div>-->
<!--      <div style="width: 100%;height: 500px;overflow: scroll">-->
<!--        <div class="personal_right_tit"><a href="javascript:void(0)" class="tab_on">全部</a><a href="javascript:void(0)">已读</a><a href="javascript:void(0)">未读</a></div>-->
<!--        <ul class="personal_infor">-->
<!--          <li><span>系统消息：办件提交成功，详细进度就关注微信公众平台！详细进度就关注微信公众平台详细进度就关注微信公众平台详细进度就关注微信公众平台详细进度就关注微信公众平台详细进度就关注微信公众平台</span><em>2018-06-14  12:00</em></li>-->
<!--          <li><span>系统消息：办件提交成功，详细进度就关注微信公众平台！</span><em>2018-06-14  12:00</em></li>-->
<!--          <li><span>系统消息：办件提交成功，详细进度就关注微信公众平台！</span><em>2018-06-14  12:00</em></li>-->
<!--          <li><span>系统消息：办件提交成功，详细进度就关注微信公众平台！</span><em>2018-06-14  12:00</em></li>-->
<!--          <li><span>系统消息：办件提交成功，详细进度就关注微信公众平台！</span><em>2018-06-14  12:00</em></li>-->
<!--          <li><span>系统消息：办件提交成功，详细进度就关注微信公众平台！</span><em>2018-06-14  12:00</em></li>-->
<!--          <li><span>系统消息：办件提交成功，详细进度就关注微信公众平台！</span><em>2018-06-14  12:00</em></li>-->
<!--          <li><span>系统消息：办件提交成功，详细进度就关注微信公众平台！</span><em>2018-06-14  12:00</em></li>-->
<!--        </ul>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</template>-->
<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="-" :loginShow="loginShow" :gotoIndex="gotoIndex"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <span>个人中心</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>
        <div class="wraper">
          <div class="personal">

            <personal pageType="message"></personal>
            <div class="personal_right">
              <h2  class="tit8 line_bottom"><span><img src="../../../static/images/notice_sign1.png"> 消息中心</span></h2>
              <div style="width: 100%;" v-if="message_list && message_list.length>0">
              <ul class="personal_infor">
                <li v-for="(item,index) in message_list" :key="index"  >
                  <span>
                    <el-tag
                    type="danger"  v-if="item.muStatus=='0'"
                    effect="dark" style="width: 45px;height: 20px;line-height: 20px;margin-right: 5px;margin-top: 2px;font-size: 12px">
                    {{ item.muStatusName }}
                  </el-tag>
                    <el-tag
                      type="danger"  v-if="item.muStatus=='1'" color="#ffe1e1"
                       style="width: 45px;height: 20px;line-height: 20px;margin-right: 5px;margin-top: 2px;font-size: 12px">
                    {{ item.muStatusName }}
                  </el-tag>
                    <a href="javascript:void(0)" @click="readMsg(item)">
                    {{item.msgContent}}</a>      <a href="javascript:void(0)" v-if="item.catagoryCode==='apply'" @click="readMsgGoTo(item,item.muId)" style="color: #2b60e2;font-style: italic">>查看详情</a></span>

                  <em>{{item.mTime}}</em>
                </li>

              </ul>

              </div>

              <div v-else>
                <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);margin-top: 50px;">
                  <div><img src="../../../static/images/empty-image-default.png" style="width: 300px;" /></div>
                  <div>暂无数据</div>
                </div>
              </div>
              <div class="clear"></div>
              <div style="text-align: center;height: 50px;line-height: 50px;" v-if="message_list.length>0"> <el-pagination
                layout="prev, pager, next"
                :total="pageTotal" :page-size="pageSize" @current-change="pageChange" @prev-click="prevClick" @next-click="nextClieck">
              </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <footers></footers>
  </div>
</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";
  import personal from "../../components/Personal";
  export default {
    name: "Message",
    components: {
      headers, fixedDiv, footers,personal
    },
    data(){
      return{
        message_list:[],
        loginShow:false,
        gotoIndex:false,
        pageNum:1,
        pageSize:10,
        pageTotal:0,
      }
    },
    mounted() {
      var userInfo=this.$cookies.get('userInfo')
      if(!userInfo || userInfo.userId =='' || userInfo.userId ==-1){
        this.loginShow=true;
        this.gotoIndex=true;
      }
      this.getListData()
    },
    methods:{
      prevClick(a){
        this.pageNum=this.pageNum-1;
        this.getListData();
      },
      nextClieck(a){
        this.pageNum=this.pageNum+1;
        this.getListData();
      },
      pageChange(a){
        this.pageNum=a
        this.getListData();
      },
      urlTo(url,params){
        this.$router.push({path:url,query:params||{}});
      } ,
      readMsgGoTo(item){

        if (item.catagoryCode==='suggest'){
          this.readMsg(item);
        }else if (item.catagoryCode==='apply'){
          var upId = item.upId;
          this.urlTo("personal_cardMaking?upId="+upId)
          this.readMsg(item);
        }else if (item.catagoryCode==='appointment'){
          this.readMsg(item);
        }

      },
      readMsg(item){
        if(item.muStatus=='0'){
          item.muStatus='1';
          item.muStatusName='已读';
          this.$https.post("api/msg/editMessage.do",{muId:item.muId},response=>{
            // if (response.status === 200 && response.data.code===200 && response.data.data !=null) {
            //   this.dataList=response.data.data;
            // }else{
            // }
          })
        }
      },
      getListData() {
        const options={
          typeId:2,
          pageNum:this.pageNum,
          pageSize:this.pageSize
        };
        this.$https.post("/api/msg/getAllMessage.do", options, response => {
          if (response.status === 200 && response.data.code === 200) {
            if (!this.$util.isEmpty(response.data.data)) {
              this.message_list = response.data.data;
              this.pageTotal = this.message_list[0].total
            }
          }
        });
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/personal/Message.vue